var _path, _path2, _path3, _g, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilterBlueIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.40025 11.4939H1.14941C0.804414 11.4939 0.524414 11.2139 0.524414 10.8689C0.524414 10.5239 0.804414 10.2439 1.14941 10.2439H6.40025C6.74525 10.2439 7.02525 10.5239 7.02525 10.8689C7.02525 11.2139 6.74525 11.4939 6.40025 11.4939Z",
    fill: "#2C3782"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.9922 3.41699H8.74219C8.39719 3.41699 8.11719 3.13699 8.11719 2.79199C8.11719 2.44699 8.39719 2.16699 8.74219 2.16699H13.9922C14.3372 2.16699 14.6172 2.44699 14.6172 2.79199C14.6172 3.13699 14.3372 3.41699 13.9922 3.41699Z",
    fill: "#2C3782"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_34234_4814",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 6,
    height: 6
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.5 0.166992H5.68817V5.32666H0.5V0.166992Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_34234_4814)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.09417 1.41675C2.35333 1.41675 1.75 2.01341 1.75 2.74758C1.75 3.48092 2.35333 4.07675 3.09417 4.07675C3.83583 4.07675 4.43833 3.48092 4.43833 2.74758C4.43833 2.01341 3.83583 1.41675 3.09417 1.41675ZM3.09417 5.32675C1.66417 5.32675 0.5 4.17008 0.5 2.74758C0.5 1.32508 1.66417 0.166748 3.09417 0.166748C4.525 0.166748 5.68833 1.32508 5.68833 2.74758C5.68833 4.17008 4.525 5.32675 3.09417 5.32675Z",
    fill: "#2C3782"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.4895 9.50659C11.7479 9.50659 11.1445 10.1033 11.1445 10.8366C11.1445 11.5708 11.7479 12.1666 12.4895 12.1666C13.2304 12.1666 13.8329 11.5708 13.8329 10.8366C13.8329 10.1033 13.2304 9.50659 12.4895 9.50659ZM12.4895 13.4166C11.0587 13.4166 9.89453 12.2591 9.89453 10.8366C9.89453 9.41409 11.0587 8.25659 12.4895 8.25659C13.9195 8.25659 15.0829 9.41409 15.0829 10.8366C15.0829 12.2591 13.9195 13.4166 12.4895 13.4166Z",
    fill: "#2C3782"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterBlueIcon);
export default __webpack_public_path__ + "static/media/FilterBlueIcon.fe305663.svg";
export { ForwardRef as ReactComponent };